export default __webpack_public_path__ + "static/media/38.84757a54.jpg";